// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"7b27230f","818":"7b27230f"}[chunkId] + ".chunk.css";
};